import { DynTimeline } from '../utils/Timeline'
import Noise from '@mohayonao/perlin-noise'

const perlin = new Noise(Math.random)
const setShapeTrans = (data, x, y, rot = 0, scale = 1) =>
{
    data.el.style.transform = 'translate3D('
        + x * 100 / data.size[0] + '%, '
        + y * 100 / data.size[1] + '%, 0) '
        + 'rotate(' + rot + 'deg) '
        + 'scale(' + scale + ', ' + scale + ')'
}

export default
{
    data() {
        return {
            seedsList: this.getSeedsList()
        }
    },

    created()
    {
        this.currentState = 0
        this.eventHub.$on('product:select', this.setState)
    },

    mounted()
    {
        this.state = new DynTimeline(0, 1000, 0.42, 0, 0.37, 1)
        this.time = window.performance.now()

        this.initSeeds()
        this.initShapes()
        
        this.setState()
        this.tick(this.time)
    },
    
    destroyed()
    {
        this.eventHub.$off('product:select', this.setState)
        cancelAnimationFrame(this.tickRaf)
    },

    methods:
    {
        // -----------------------
        //
        //     INIT (GENERAL)
        //
        // -----------------------

        getSeedsList()
        {
            const seedsList = [
                [
                    { src: require('../../assets/seeds/left/cacao-6.png'),  x: -1,       y: -0.9,    rot: 0 },
                    { src: require('../../assets/seeds/left/cacao-5.png'),  x: -7.5/8,   y: -4.6/8,  rot: 0 },
                    { src: require('../../assets/seeds/left/cacao-4.png'),  x: -7/8,     y: -2.5/8,  rot: 0 },
                    { src: require('../../assets/seeds/left/cacao-3.png'),  x: -6.5/8,   y: -1/8,    rot: 0 },
                    { src: require('../../assets/seeds/left/ball.png'),     x: -6/8,     y: 1.2/8,   rot: 0 },
                    { src: require('../../assets/seeds/left/cacao-2.png'),  x: -3.5/8,   y: 2.5/8,   rot: 0 },
                    { src: require('../../assets/seeds/left/cacao-1.png'),  x: -3/8,     y: 4/8,     rot: 0 },
                    { src: require('../../assets/seeds/left/epi.png'),      x: -5.5/8,   y: 1.2,     rot: 0 }
                ],
                [
                    { src: require('../../assets/seeds/right/cacao-1.png'), x: -3/8, y: -0.9,   rot: 0 },
                    { src: require('../../assets/seeds/right/ball.png'),    x: -5/8,   y: -4.6/8, rot: 0 },
                    { src: require('../../assets/seeds/right/epi.png'),     x: -6/8,   y: 2/8, rot: 0 },
                    { src: require('../../assets/seeds/right/cacao-2.png'), x: -5/8,   y: 3/8,   rot: 0 },
                    { src: require('../../assets/seeds/right/cacao-3.png'), x: -5.8/8, y: 4.5/8,    rot: 0 },
                    { src: require('../../assets/seeds/right/cacao-4.png'), x: -4.5/8,     y: 5.5/8,    rot: 0 },
                    { src: require('../../assets/seeds/right/cacao-5.png'), x: -7/8,     y: 1,    rot: 0 },
                    { src: require('../../assets/seeds/right/cacao-6.png'), x: -0.7,     y: 1.15,    rot: 0 }
                ],
                []
            ]

            seedsList.push(seedsList[0])
            return seedsList
        },

        initSeeds()
        {
            const setSeedData = (seeds, group) => seeds.map(({ x, y, rot }, index) =>
            {
                const el = this.$refs['seed' + group][index]
                el.style.transform = `translateX(${x * 20}vw) translateY(50px) translateY(${100 + y * 40}vh) rotate(${rot}deg) translateZ(0)`
                el.style.transitionDuration = '0s'

                return { el, index, x, y, rot }
            })

            this.seedsData = this.seedsList.map(setSeedData)
        },

        initShapes()
        {
            const duration = 500
            this.shapesData = [
                {
                    el: this.$refs.shape1,
                    pos: new DynTimeline([0.5, 0.5], duration),
                    rot: new DynTimeline(0, duration),
                    scale: new DynTimeline(1, duration),
                    size: [1, 1]
                },
                {
                    el: this.$refs.shape2,
                    pos: new DynTimeline([0.5, 0.5], duration),
                    rot: new DynTimeline(0, duration),
                    scale: new DynTimeline(1, duration),
                    size: [2 / 3, 2 / 6]
                },
                {
                    el: this.$refs.shape3,
                    pos: new DynTimeline([0.5, 0.5], duration),
                    rot: new DynTimeline(0, duration),
                    scale: new DynTimeline(1, duration),
                    size: [1 / 3, 1 / 3]
                }
            ]
        },
        
        // -----------------------
        //
        //        UPDATE
        //
        // -----------------------

        tick(time)
        {
            this.time = time
            const shapesTrans = this.getShapePermTrans()
            this.shapesData.forEach((data, index) =>
            {
                const { pos, rot, scale } = shapesTrans[index]
                setShapeTrans(data,
                    ...data.pos.getValue(time).map((p, i) => p + pos[i]),
                    data.rot.getValue(time) + rot,
                    data.scale.getValue(time) * scale)
            })
            
            this.tickRaf = requestAnimationFrame(this.tick)
        },

        setState(num = 1)
        {
            this.state.change(num, this.time)
            this.setSeedsTrans(num - 1, this.currentState - 1)
            switch (num)
            {
                case 0 :
                    this.setShapeTransAnim1()
                    break
                case 1 :
                    this.setShapeTransAnim1()
                    break
                case 2 :
                    this.setShapeTransAnim2()
                    break
                // case 3 :
                //     this.setShapeTransAnim3()
                //     break
                // case 4 :
                //     this.setShapeTransAnim4()
                //     break
                case 3 :
                    this.setShapeTransAnimOut()
                    break
            }

            this.currentState = num
        },
        

        // -----------------------
        //
        //      SHAPES INIT
        //
        // -----------------------
        
        getShapePermTrans0()
        {
            return [
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 }
            ]
        },
        
        getShapePermTrans1()
        {
            const v = perlin.noise(this.time / 5000) - 0.5
            
            return [
                {
                    pos: [-v * 0.1, 0],
                    rot: 0,
                    scale: 1
                },
                {
                    pos: [v * 0.2, Math.abs(v) * 0.01],
                    rot: v * 40,
                    scale: 1
                },
                {
                    pos: [-v * 0.5, -Math.abs(v) * 0.05],
                    rot: 0,
                    scale: 1
                }
            ]
        },
        
        getShapePermTrans2()
        {
            return [
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 }
            ]
        },

        getShapePermTrans3()
        {
            return [
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 }
            ]
        },

        getShapePermTrans4()
        {
            const vel = this.time / 15000
            const v1 = 0.25 * perlin.noise(0x56 + vel) - 0.125
            const v2 = 0.25 * perlin.noise(0xF3 + vel) - 0.125
            const v3 = 0.25 * perlin.noise(0x36 + vel) - 0.125
            const v4 = 0.25 * perlin.noise(0x16 + vel) - 0.125
            const v5 = 0.25 * perlin.noise(0x29 + vel) - 0.125
            const v6 = 0.25 * perlin.noise(0xA9 + vel) - 0.125
            
            return [
                { pos: [v1, v4], rot: 0, scale: 1 },
                { pos: [v2, v5], rot: 0, scale: 1 },
                { pos: [v3, v6], rot: 0, scale: 1 }
            ]
        },

        getShapePermTrans5()
        {
            return [
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 },
                { pos: [0, 0], rot: 0, scale: 1 }
            ]
        },

        getShapePermTrans()
        {
            const state = this.state.getValue(this.time)
            const currentTrans = [
                {pos: [0, 0], rot: 0, scale: 1},
                {pos: [0, 0], rot: 0, scale: 1},
                {pos: [0, 0], rot: 0, scale: 1}
            ]

            for (let s = 0; s < 6; s++)
            {
                const dist = 1 - Math.abs(s - state)
                if (dist > 0)
                {
                    for (let n = 0; n < currentTrans.length; n++)
                    {
                        const permTrans = this['getShapePermTrans' + s]()
                        currentTrans[n].pos[0] += dist * permTrans[n].pos[0]
                        currentTrans[n].pos[1] += dist * permTrans[n].pos[1]
                        currentTrans[n].rot += dist * permTrans[n].rot
                        currentTrans[n].scale *= dist * (permTrans[n].scale - 1) + 1
                    }
                }
            }

            return currentTrans
        },
        
        // -----------------------
        //
        //       SHAPES SET
        //
        // -----------------------
        
        setShapeTransAnimOut()
        {
            this.shapesData[0].pos.change([2.75, 2 / 3 - 0.33], this.time)
            this.shapesData[0].rot.change(0, this.time)
            this.shapesData[0].scale.change(1, this.time)
            
            this.shapesData[1].pos.change([2.75, -0.33], this.time)
            this.shapesData[1].rot.change(0, this.time)
            this.shapesData[1].scale.change(1, this.time)
            
            this.shapesData[2].pos.change([2.75, -1 / 3 - 0.33], this.time)
            this.shapesData[2].rot.change(0, this.time)
            this.shapesData[2].scale.change(1, this.time)
        },

        setShapeTransAnim1()
        {
            this.shapesData[0].pos.change([0.75, 2 / 3 - 0.33], this.time)
            this.shapesData[0].rot.change(0, this.time)
            this.shapesData[0].scale.change(1, this.time)
            
            this.shapesData[1].pos.change([0.75, -0.33], this.time + 125)
            this.shapesData[1].rot.change(0, this.time + 125)
            this.shapesData[1].scale.change(1, this.time + 125)
            
            this.shapesData[2].pos.change([0.75, -1 / 3 - 0.33], this.time + 250)
            this.shapesData[2].rot.change(0, this.time + 250)
            this.shapesData[2].scale.change(1, this.time + 250)
        },

        setShapeTransAnim2()
        {
            const duration = this.shapesData[0].pos.duration * 0.6
            const cubicBezier = [0.6, 0.03, 1, 0.75]

            this.shapesData[0].pos.change([0.75, 0], this.time, duration, 0.58, 0.13, 0.49, 0.95)
            this.shapesData[0].rot.change(0, this.time, duration, 0.58, 0.13, 0.49, 0.95)
            this.shapesData[0].scale.change(1.4, this.time, duration, 0.58, 0.13, 0.49, 0.95)
            
            this.shapesData[1].pos.change([0.75, 0.53], this.time + 65, duration, ...cubicBezier)
            this.shapesData[1].rot.change(0, this.time, duration)
            this.shapesData[1].scale.change(1, this.time, duration)
            
            this.shapesData[2].pos.change([0.75, 0.2], this.time + 200, duration, ...cubicBezier)
            this.shapesData[2].rot.change(0, this.time, duration)
            this.shapesData[2].scale.change(1, this.time, duration)
        },

        setShapeTransAnim3()
        {
            this.shapesData[0].pos.change([0.75, 2 / 3 - 0.33], this.time)
            this.shapesData[0].rot.change(0, this.time)
            this.shapesData[0].scale.change(1, this.time)
            
            this.shapesData[1].pos.change([0.75, -1 / 3 - 0.33], this.time)
            this.shapesData[1].rot.change(0, this.time)
            this.shapesData[1].scale.change(1, this.time)
            
            this.shapesData[2].pos.change([0.75, -0.33], this.time)
            this.shapesData[2].rot.change(0, this.time)
            this.shapesData[2].scale.change(1, this.time)
        },

        setShapeTransAnim4()
        {
            const duration = this.shapesData[0].pos.duration * 2.6
            const cubicBezier = [0.22, 0.01, 0, 0.99]

            this.shapesData[0].pos.change([1, 0], this.time, duration, ...cubicBezier)
            this.shapesData[0].rot.change(0, this.time, duration, ...cubicBezier)
            this.shapesData[0].scale.change(1.4, this.time)
            
            this.shapesData[1].pos.change([0.075, 0], this.time, duration, ...cubicBezier)
            this.shapesData[1].rot.change(-90, this.time, duration, ...cubicBezier)
            this.shapesData[1].scale.change(1, this.time)
            
            this.shapesData[2].pos.change([-1 / 3, 0], this.time, duration, ...cubicBezier)
            this.shapesData[2].rot.change(0, this.time, duration, ...cubicBezier)
            this.shapesData[2].scale.change(1, this.time)
        },

        // -----------------------
        //
        //        SEEDS
        //
        // -----------------------

        setSeedsTrans(num, lastNum)
        {
            const toTop = lastNum < num
            const isBorder = (num === 0 && lastNum < num) || (num === this.seedsData.length && lastNum > num) 
            this.seedsData.forEach((seeds, group) => seeds.forEach(({ x, y, el, rot }, index) =>
            {
                if (group === num)
                {
                    el.style.transform = `translateX(${x * 20}vw) translateY(${y * 40}vh) translateY(50px) rotate(${rot}deg) translateZ(0)`
                    el.style.transitionDelay = (isBorder ? 0 : 0.5) + 's'
                    el.style.transitionDuration = (toTop ? index * 0.05 + 0.2 : ((seeds.length - index - 1)) * 0.05 + 0.2) + 's'
                }
                else if (group === lastNum)
                {
                    const decal = toTop ? -100 : 100
                    el.style.transform = `translateX(${x * 20}vw) translateY(${decal + y * 40}vh) translateY(50px) rotate(${rot}deg) translateZ(0)`
                    el.style.transitionDelay = '0s'
                    el.style.transitionDuration = (toTop ? index * 0.05 + 0.2 : ((seeds.length - index - 1)) * 0.05 + 0.2) + 's'
                }
            }))
        }
    }
}